/* Progressive enhancement: every product remains visible without JavaScript. */
if (!customElements.get('evvo-cookware-finder')) {
  customElements.define('evvo-cookware-finder', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.choices = this.querySelector('[data-finder-choices]');
      this.tabs = Array.from(this.querySelectorAll('[data-finder-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-finder-panel]'));
      if (!this.choices || !this.tabs.length || this.tabs.length !== this.panels.length) return;

      this.choices.setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[index].id);
        this.panels[index].setAttribute('role', 'tabpanel');
        this.panels[index].setAttribute('aria-labelledby', tab.id);
        this.panels[index].tabIndex = 0;
        tab.addEventListener('click', (event) => {
          event.preventDefault();
          this.select(index);
        }, { signal });
        tab.addEventListener('keydown', (event) => {
          const rtl = getComputedStyle(this).direction === 'rtl';
          let next;
          if (event.key === 'ArrowRight') next = index + (rtl ? -1 : 1);
          if (event.key === 'ArrowLeft') next = index + (rtl ? 1 : -1);
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === ' ') next = index;
          if (next === undefined) return;
          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        }, { signal });
      });
      this.select(0, { scrollTabIntoView: false });

      window.addEventListener('resize', () => this.updateIndicator(), { signal });

      document.addEventListener('shopify:block:select', (event) => {
        const index = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail?.blockId);
        if (index !== -1) this.select(index);
      }, { signal });
    }

    select(index, { scrollTabIntoView = true } = {}) {
      this.tabs.forEach((tab, position) => {
        const selected = position === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        this.panels[position].hidden = !selected;
      });

      requestAnimationFrame(() => {
        this.updateIndicator();
        if (!scrollTabIntoView) return;
        this.tabs[index].scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    }

    updateIndicator() {
      const activeTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      if (!activeTab || !this.choices) return;

      const containerRect = this.choices.getBoundingClientRect();
      const tabRect = activeTab.getBoundingClientRect();
      const offset = tabRect.left - containerRect.left + this.choices.scrollLeft;
      this.choices.style.setProperty('--finder-indicator-x', `${offset}px`);
      this.choices.style.setProperty('--finder-indicator-width', `${tabRect.width}px`);
      this.choices.dataset.finderReady = 'true';
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
